// extracted by mini-css-extract-plugin
module.exports = {"save_Btn":"SaveResetButtonV2_save_Btn__3TgZo","reset_Btn":"SaveResetButtonV2_reset_Btn__19Aid"};